import React from "react";
import "./../../scss/global.scss";

function Page404() {
  return <div className="screen-404 flex align-center center bg-primary h-100 color-white">Brak informacji o pokoju, zeskanuj kod QR umieszczony w pokoju.</div>;
}

export default Page404;
